/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { UiSliderStyle_Enum, uiSliderStyle_EnumFromJSON, uiSliderStyle_EnumToJSON } from "./ui_slider_style";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiSlider {
  id: string;
  label: string;
  detail: string;
  units: string;
  style: UiSliderStyle_Enum;
  maxValue: number;
  minValue: number;
  value: number;
  displayPrecision: number;
  stepSize: number;
  disabled: boolean;
}

function createBaseUiSlider(): UiSlider {
  return {
    id: "",
    label: "",
    detail: "",
    units: "",
    style: 0,
    maxValue: 0,
    minValue: 0,
    value: 0,
    displayPrecision: 0,
    stepSize: 0,
    disabled: false,
  };
}

export const UiSlider = {
  encode(message: UiSlider, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    if (message.detail !== "") {
      writer.uint32(26).string(message.detail);
    }
    if (message.units !== "") {
      writer.uint32(34).string(message.units);
    }
    if (message.style !== 0) {
      writer.uint32(64).int32(message.style);
    }
    if (message.maxValue !== 0) {
      writer.uint32(45).float(message.maxValue);
    }
    if (message.minValue !== 0) {
      writer.uint32(53).float(message.minValue);
    }
    if (message.value !== 0) {
      writer.uint32(61).float(message.value);
    }
    if (message.displayPrecision !== 0) {
      writer.uint32(72).sint32(message.displayPrecision);
    }
    if (message.stepSize !== 0) {
      writer.uint32(85).float(message.stepSize);
    }
    if (message.disabled === true) {
      writer.uint32(88).bool(message.disabled);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiSlider {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiSlider();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.detail = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.units = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.style = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.maxValue = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.minValue = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.value = reader.float();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.displayPrecision = reader.sint32();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.stepSize = reader.float();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.disabled = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UiSlider {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      detail: isSet(object.detail) ? globalThis.String(object.detail) : "",
      units: isSet(object.units) ? globalThis.String(object.units) : "",
      style: isSet(object.style) ? uiSliderStyle_EnumFromJSON(object.style) : 0,
      maxValue: isSet(object.maxValue) ? globalThis.Number(object.maxValue) : 0,
      minValue: isSet(object.minValue) ? globalThis.Number(object.minValue) : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      displayPrecision: isSet(object.displayPrecision) ? globalThis.Number(object.displayPrecision) : 0,
      stepSize: isSet(object.stepSize) ? globalThis.Number(object.stepSize) : 0,
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : false,
    };
  },

  toJSON(message: UiSlider): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.detail !== "") {
      obj.detail = message.detail;
    }
    if (message.units !== "") {
      obj.units = message.units;
    }
    if (message.style !== 0) {
      obj.style = uiSliderStyle_EnumToJSON(message.style);
    }
    if (message.maxValue !== 0) {
      obj.maxValue = message.maxValue;
    }
    if (message.minValue !== 0) {
      obj.minValue = message.minValue;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    if (message.displayPrecision !== 0) {
      obj.displayPrecision = Math.round(message.displayPrecision);
    }
    if (message.stepSize !== 0) {
      obj.stepSize = message.stepSize;
    }
    if (message.disabled === true) {
      obj.disabled = message.disabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UiSlider>, I>>(base?: I): UiSlider {
    return UiSlider.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiSlider>, I>>(object: I): UiSlider {
    const message = createBaseUiSlider();
    message.id = object.id ?? "";
    message.label = object.label ?? "";
    message.detail = object.detail ?? "";
    message.units = object.units ?? "";
    message.style = object.style ?? 0;
    message.maxValue = object.maxValue ?? 0;
    message.minValue = object.minValue ?? 0;
    message.value = object.value ?? 0;
    message.displayPrecision = object.displayPrecision ?? 0;
    message.stepSize = object.stepSize ?? 0;
    message.disabled = object.disabled ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
